const trackEidError = () => {
    let element = document.querySelector('.eid-number-error-message');

    if (element) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'error',
            error_line: '',
            error_message: element.textContent,
            error_type: 'customer error',
        });
    }
};

export default trackEidError;
